// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dialog-keep-subscription hr{border-bottom:none;border-top:1px solid var(--v-gray-base);margin:24px 0}.dialog-keep-subscription__title{display:block;font-size:20px;margin-bottom:14px}@media screen and (min-width:960px){.dialog-keep-subscription__title{font-size:16px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
